import { render, staticRenderFns } from "./zen_what_is.vue?vue&type=template&id=070ba510&scoped=true&"
import script from "./zen_what_is.vue?vue&type=script&lang=js&"
export * from "./zen_what_is.vue?vue&type=script&lang=js&"
import style0 from "./zen_what_is.vue?vue&type=style&index=0&id=070ba510&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070ba510",
  null
  
)

export default component.exports